import React from 'react';
import ModernCompanies from '../components/ModernCompanies';

// Neutral placeholder for the handful of companies without a photo (11/571).
export function CompanyBannerFallback({ name, symbol }) {
  return (
    <div className="w-full h-full flex items-center justify-center" style={{ backgroundColor: 'var(--color-primary, #1a2332)' }}>
      <span className="text-4xl font-bold text-white/25" style={{ fontFamily: 'Playfair Display, serif' }}>
        {(symbol || name || '?').slice(0, 4).toUpperCase()}
      </span>
    </div>
  );
}

// /companies — one expanded listing for every brand (s153): the «Moderno»
// page approved in s140 (photo/logo views, portfolio, Earning Announcement),
// skinned per theme (lib/opportunitySkin).
export default function CompaniesPage() {
  return <ModernCompanies />;
}
